import { makeStyles } from "@material-ui/core/styles";

const myTeamBillingsPageStyles = makeStyles((theme) => ({
  pageWrapper: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },

  warningBox: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    backgroundColor: "#EFB13A4D",
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #EFB13A",
    color: "#F9F9F9",
  },

  warningAction: {
    marginLeft: "auto",
    cursor: "pointer",
    fontWeight: 500,
  },

  contentWrapper: {
    display: "flex",
    gap: "16px",
    padding: "10px 0px",
    borderRadius: "8px",
    color: "#F9F9F9",
  },

  card: {
    padding: "20px",
    borderRadius: "10px",
    border: "1px solid #606479",
    color: "#F9F9F9",
    width: "100%",
    fontSize: "14px",
  },

  cardContent: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    fontSize: "14px !important",
  },
  commonText: {
    fontSize: "14px !important",
  },

  planHeader: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
  },

  planBadge: {
    border: "1px solid #B1B5C9",
    borderRadius: "20px",
    padding: "4px 12px",
    display: "inline-block",
    fontSize: "14px",
    fontWeight: "500",
    color: "#B1B5C9",
  },
  pendingStatus: {
    backgroundColor: "#EFB13A29",
    borderRadius: "20px",
    padding: "4px 12px",
    display: "inline-block",
    fontSize: "14px",
    color: "#EFB13A",
  },
  paidStatus: {
    backgroundColor: "#3AEF5529",
    borderRadius: "20px",
    padding: "4px 12px",
    display: "inline-block",
    fontSize: "14px",
    color: "#61FF79",
  },

  divider: {
    // margin: "20px 0",
    backgroundColor: "#606479",
  },

  infoList: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },

  infoRow: {
    display: "flex",
    alignItems: "center",
    gap: "40px",
  },

  infoLabel: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    color: "#B1B5C9",
    width: "150px",
  },

  infoValue: {
    color: "#F9F9F9",
    fontSize: "14px",
  },

  tableHeaderCell: {
    borderBottom: `1px solid ${theme.palette.secondary.light} !important`,
    backgroundColor: "transparent !important",
    color: `${theme.palette.text.tertiary} !important`,
    width: "25%",
    fontFamily: "Poppins !important",
  },
  tableCell: {
    borderBottom: `1px solid ${theme.palette.secondary.light} !important`,
    color: "#fff !important",
    width: "25%",
    fontFamily: "Poppins !important",
    fontSize: "14px !important",
    padding: "6px 4px !important",
  },
  floatingDiv: {
    position: "fixed",
    right: "20px",
    width: "550px",
    borderRadius: "10px",
    overflowX: "hidden",
    overflowY: "hidden",
    zIndex: "100",
  },
  flexCenter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export default myTeamBillingsPageStyles;
